const Provinces = [
  { value: 'Bulawayo Metropolitan', label: 'Bulawayo Metropolitan' },
  { value: 'Harare Metropolitan', label: 'Harare Metropolitan' },
  { value: 'Manicaland', label: 'Manicaland' },
  { value: 'Masvingo', label: 'Masvingo' },
  { value: 'Midlands', label: 'Midlands' },
  { value: 'Mashonaland West', label: 'Mashonaland West' },
  { value: 'Mashonaland East', label: 'Mashonaland East' },
  { value: 'Mashonaland Central', label: 'Mashonaland Central' },
  { value: 'Matebeleland South', label: 'Matebeleland South' },
  { value: 'Matebeleland North', label: 'Matebeleland North' }
];

export default Provinces;
